import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { InterviewStressResistance } from './interview-stress-resistance';
export { InterviewStressResistance };
import { interviewStressResistanceSchema } from '@schemas/business-objects/interview-stress-resistance';
import { InterviewFormGroup } from './interview-form-group';

export class InterviewStressResistanceFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    stressResistanceScore: SchemaFormControl;
    notes: SchemaFormControl;
    interviewId: SchemaFormControl;
    interview: InterviewFormGroup;
  };

  declare value: Partial<InterviewStressResistance>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(
      interviewStressResistanceSchema,
      InterviewStressResistance,
      data,
      options,
    );
  }

  get object(): InterviewStressResistance {
    return new InterviewStressResistance(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'interview':
        return new InterviewFormGroup();
      default:
        return undefined;
    }
  }
}

export class InterviewStressResistanceFormArray extends PersistedFormArray {
  readonly entityName = 'InterviewStressResistance' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(interviewStressResistanceSchema, InterviewStressResistance, options);
  }

  protected override createItemGroup() {
    return new InterviewStressResistanceFormGroup();
  }

  get array(): InterviewStressResistance[] {
    return this.controls.map(
      (group: InterviewStressResistanceFormGroup) => group.object,
    );
  }
}

export class InterviewStressResistancePersistedArray extends PersistedArray<InterviewStressResistance> {
  readonly entityName = 'InterviewStressResistance' as const;

  constructor(options?: PersistedArrayOptions) {
    super(InterviewStressResistance, options);
  }
}
